import { loadKakaoMaps } from '../../../lib/kakaoMaps';

/**
 * 장소 «글자» 하나를 좌표로 바꾼다 — 이 파일이 **SDK 경계**다.
 *
 * ⭐ 이 한 겹을 따로 둔 까닭: 시험에서 흉내 낼 것을 «여기까지»로 한정하기 위해서다.
 *   카카오 SDK 를 통째로 mock 하면 그 «안»의 판정(무엇을 찾을지·언제 안 그릴지·캐시)이
 *   아무것도 안 잠긴다 — 이 레포가 여러 번 겪은 자리다.
 *   ⇒ 시험은 이 모듈만 흉내 내고, 그 바깥(`EventLocationMap`)은 «진짜»를 돌린다.
 *
 * ⚠ 찾기는 `services.Places.keywordSearch` 를 쓴다 — 장소 고르개가 쓰는 것과 «같은» 길이다
 *   (`LocationPicker.tsx`). 그래서 고르개가 넣어 둔 글자는 대체로 그대로 되찾아진다.
 *   ⇒ 로더가 `&libraries=services` 를 늘 붙이므로 따로 켤 것이 없다(`lib/kakaoMaps.ts`).
 */
export interface GeoPos { lat: number; lng: number }

export async function geocodeLocation(query: string): Promise<GeoPos | null> {
  await loadKakaoMaps();
  const { kakao } = window;
  const places = new kakao.maps.services.Places();
  return new Promise<GeoPos | null>((resolve) => {
    places.keywordSearch(query, (data: Array<{ x: string; y: string }>, status: string) => {
      if (status !== kakao.maps.services.Status.OK || !data?.length) { resolve(null); return; }
      const first = data[0];
      const lat = Number(first?.y);
      const lng = Number(first?.x);
      // ⚠ 카카오는 좌표를 «문자열»로 준다. 숫자가 아니면 핀을 못 꽂으므로 없는 것으로 다룬다.
      resolve(Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null);
    });
  });
}
